module.exports = __webpack_public_path__ + "img/volinta_logo.c1706d9a.png";